import axios from 'axios';

import { APIError, UnsupportedStructureError } from '~services/Errors';

import { DeobfuscationResponseDecoder } from './domain';

export const getDeobfucatedValue = async (token: string): Promise<string> => {
  const path = `/api/deobfuscate/${token}`;
  let response;

  try {
    response = await axios.request({
      url: path,
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });
  } catch (e) {
    if (axios.isAxiosError(e)) {
      // Response should always be defined if axios error
      throw new APIError(e.response!.status, (e.response!.data as { error: string }).error || e.message);
    }

    throw new APIError(-1, e as string);
  }

  const decoded = DeobfuscationResponseDecoder.run(response.data);
  if (decoded.ok === false) {
    const err = new UnsupportedStructureError(decoded.error.message);

    console.error(decoded.error);
    console.error(err);
    throw err;
  }

  return decoded.result;
};
